import React from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';

import NextPageLinkDesktop from './NextPageLink/NextPageLinkDesktop';
import NextPageLinkMobile from './NextPageLink/NextPageLinkMobile';


const NextPageLinkContainer = styled.div`
  width: 100%;
`;

const switchPages = (blog) => {
  if (blog) {
    window.open('https://blog.leafycode.com/', '_blank');
  } else {
    window.PagesSweeper.slideNext(true, 1300);
  }
};

const NextPageLink = ({ image, color, text, blog }) => (
  <NextPageLinkContainer>
    <MediaQuery minWidth={992}>
      <NextPageLinkDesktop
        image={image}
        color={color}
        switchPages={() => { switchPages(blog); }}
      />
    </MediaQuery>
    <MediaQuery maxWidth={991} >
      <NextPageLinkMobile color={color} text={text} switchPages={() => { switchPages(blog); }} />
    </MediaQuery>
  </NextPageLinkContainer>
  );


export default NextPageLink;



// WEBPACK FOOTER //
// ./src/shared/NextPageLink.js